import { Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { Store } from '@ngrx/store';
import { IAppState } from '../../store/interface/app.state.interface';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { MessageService } from 'primeng/api';
import { IUser } from '../../user/interfaces/user.interface';

@Injectable()
export class ShoppingStoreGuard implements CanActivate {
    constructor(
        private store: Store<IAppState>,
        private router: Router,
        private messageService: MessageService,
    ) {}

    /*=====================================
      Closes the shop areas of the panel when the merchant has
      turned the shopping store off in Settings > Store.

      Hiding the menu entries is not enough on its own - the
      addresses still resolve if somebody types one, and the API
      would answer with a bare 403 the panel has no wording for.
      This gives the same treatment TenantGuard gives: back to the
      dashboard with a sentence saying why.

      Only an explicit false closes anything. An undefined flag
      means the account was loaded without the column rather than
      that the store is off, and that must never lock a merchant
      out of their own catalogue.
      @return whether the shop areas are open
    ======================================*/
    canActivate(): Observable<boolean | UrlTree> {
        return this.store
            .select((state) => state.user.loggedInUser)
            .pipe(
                map((user: IUser | null) => {
                    if (user?.tenant?.enableShoppingStore !== false) {
                        return true;
                    }

                    this.messageService.add({
                        severity: 'warn',
                        summary: 'Shopping store is off',
                        detail: 'Turn the shopping store back on in Settings › Store to use this.',
                    });

                    return this.router.parseUrl('/');
                }),
            );
    }
}
